<template>
  <v-layout wrap>
    <v-flex 
      v-if="identForm.indexOf('name')>=0"
      xs12
      style="padding: 10px;"
    >
      <v-text-field
        v-model="value.name"
        label="Name"
        outlined
        hideDetails
      />
    </v-flex>
    <v-flex 
      v-if="identForm.indexOf('room')>=0"
      xs12
      style="padding: 10px;"
    >
      <v-text-field
        v-model="value.room"
        label="Room"
        outlined
        hideDetails
      />
    </v-flex>
    <v-flex 
      xs6
      style="padding: 10px;"
    >
      <v-btn
        @click="onClose"
        block
      >
        {{$t('common.close', locale)}}
      </v-btn>
    </v-flex>
    <v-flex 
      xs6
      style="padding: 10px;"
    >
      <v-btn
        @click="handleSave"
        block
        color="primary"
        dark
      >
        {{$t('common.save', locale)}}
      </v-btn>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  props: {
    locale: {
      type: String,
      required: true,
    },
    identForm: {
      type: Array,
      required: true,
    },
    onClose: {
      type: Function,
      required: true,
    },
    onSave: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    value: {},
  }),
  methods: {
    handleSave () {
      if (this.identForm.filter(x => !this.value[x] || this.value[x].length === 0).length > 0) {
        alert('Item Required')
        return
      }
      this.onSave(this.value)
    },
  }
}
</script>

